import { Directive, ElementRef, HostListener, inject } from "@angular/core";

@Directive({
  selector: "input[type='number'][appQtyInput]",
  standalone: true,
})
export class QtyInputSelectZeroDirective {
  private readonly elementRef = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @HostListener("focus")
  onFocus(): void {
    this.selectZeroValue();
  }

  @HostListener("click")
  onClick(): void {
    this.selectZeroValue();
  }

  private selectZeroValue(): void {
    const input = this.elementRef.nativeElement;
    if (input.disabled || input.readOnly || input.value !== "0") {
      return;
    }

    setTimeout(() => {
      if (input.value !== "0") {
        return;
      }

      input.select();

      try {
        input.setSelectionRange(0, input.value.length);
      } catch {
        // Some number inputs do not support explicit selection ranges.
      }
    }, 0);
  }
}
